module.exports = __webpack_public_path__ + "static/media/крымчане.64f80307.jpg";